module.exports = __webpack_public_path__ + "media/plane.cc67c3be.mp4";